<template>
	<div class="i-toast" v-if="show" :class="{animate:animate}">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'i-toast',
		data() {

			return {
				show:false,
				animate:false
			}
		},
		mounted() {

		},
		methods: {
			// handleScroll() {
			open(){
				var that=this
				this.show=!this.show
				
				setTimeout(()=>{
					that.animate=true
					setTimeout(()=>{
						that.animate=false
						this.show=false
					},2000)
				},50)
				
			}
		},

	}
</script>

<style scoped="scoped" lang="less">
	.i-toast {
		position: fixed;
		z-index: 10000;
		left: 50%;
		top: 50%;
		transform: translateX(-50%) translateY(-50%) scale(0.1);
		background: rgba(0, 0, 0, .75);
		border-radius: 5px;
		max-width: 200px;
		line-height: 1.5em;
		padding: 10px 15px;
		font-size: 14px;
		color: #fff;
		opacity: 0;
		
		transition: 0.3s;
	}
	.animate{
		opacity: 1;
		transform: translateX(-50%) translateY(-50%) scale(1);
	}
</style>
